import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
} from '../../../business-components/Formata/Formata'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    DivOverflowX,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem10,
} from '../../../business-components/Grid/Grid'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    titleTaxaJurosAnual,
} from './EstudoServiceComparacaoFinanciamentos'



const EstudoFormComparacaoFinanciamentoTabelaDetalhe = ( { values, estudo, report, indInicial, indFinal } ) => {

    const ComparacaoFinanciamentoTabelaDetalhe = ( props ) => {

        const aumentoLetraCabecalho = 4 - (estudo.current.descricaoSaldoVendaAposQuitacao ? 1 : 0)
        const aumentoLetraReportCabecalho = (values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 2 : 4) -
            (estudo.current.percValorizacaoImovelAluguelAposContemplacao ? 2 : 0) -
                (estudo.current.descricaoSaldoVendaAposQuitacao ? 1 : 0)
        
        const aumentoLetra = 4 - (estudo.current.descricaoSaldoVendaAposQuitacao ? 1 : 0)
        const aumentoLetraReport = (values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 2 : 5) -
            (estudo.current.percValorizacaoImovelAluguelAposContemplacao ? 2 : 0) -
                (estudo.current.descricaoSaldoVendaAposQuitacao ? 1 : 0)

        const headList = [
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.parcela, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.mesAno, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(estudo.current.descricaoAbreviadaFinanciamentoSugerido,
                    report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
        ]

        if (values.objComparacaoFinanciamentos.idFinanciamentoAlternativo) {

            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValor(estudo.current.descricaoAbreviadaFinanciamentoAlternativo,
                        report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.economiaPerda, report, aumentoLetraCabecalho,
                        aumentoLetraReportCabecalho, values),
                },
            )

            if (values.taxaJurosAnual !== 0) { 

                headList.push(
                    {
                        colSpan: 3,
                        headTitle: formataTableCellHeadExibeDadosValor(LABEL.saldo + ' ' + LABEL.economiaPerda +
                            titleTaxaJurosAnual(values, values.taxaJurosAnual, true),
                                report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                )
            }
        }

        if (estudo.current.descricaoFinanciamentoSugeridoValorAluguelAposContemplacao) {

            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                        estudo.current.descricaoFinanciamentoSugeridoValorAluguelAposContemplacao,
                            report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.saldoAluguelAposContemplacao,
                        report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
            )

            if (estudo.current.percValorizacaoImovelAluguelAposContemplacao) {

                headList.push(
                    {
                        colSpan: 3,
                        headTitle: formataTableCellHeadExibeDadosValor(
                            estudo.current.descricaoSaldoInvestimentoAluguelAposContemplacao,
                                report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                    {
                        colSpan: 3,
                        headTitle: formataTableCellHeadExibeDadosValor(
                            estudo.current.descricaoFinanciamentoSugeridoValorizacaoImovelAluguelAposContemplacao,
                                report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                    {
                        colSpan: 3,
                        headTitle: formataTableCellHeadExibeDadosValor(LABEL.resultado,
                            report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                )

                if (estudo.current.descricaoSaldoVendaAposQuitacao) {

                    headList.push(
                        {
                            colSpan: 3,
                            headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                estudo.current.descricaoSaldoVendaAposQuitacao,
                                    report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                        },
                        {
                            colSpan: 3,
                            headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                estudo.current.descricaoSaldoAluguelAposQuitacao,
                                    report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                        },
                    )
                }
            }
        }

        if (values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista) {

            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                        LABEL.saldoPagtoFinanciamentoSugeridoAVistaQuebraEspecial + ' ' +
                            titleTaxaJurosAnual(values, values.taxaJurosAnual, true),
                                report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
            )

            if (
                    !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                    values.objComparacaoFinanciamentos.valorPagtoParcelasFinanciamentoReceitaMensal
            ) {

                headList.push(
                    {
                        colSpan: 3,
                        headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                            LABEL.saldoPagtoParcelasFinanciamentoSugeridoReceitaMensalQuebraEspecial + ' ' +
                                titleTaxaJurosAnual(values, values.taxaJurosAnual, true),
                                    report, aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                )
            }
        }

        return (
            <div
                {...props}
            >
                <TableExibeDados
                    report={report}
                >
                    <TableHeadExibeDados
                        report={report}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {estudo.current.fluxoCaixaMensalEconomiaPerdaDetalhe?.map((item, ind) => {

                            let colSpan = 0

                            return !indFinal || (ind >= indInicial && ind <= indFinal) ? (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(
                                            item.parcelas === LABEL.total ||
                                            (values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista && ind === 0)
                                                ?
                                                    ''
                                                : 
                                                    ind + 1 -
                                                        (values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista ? 1 : 0),
                                            report, false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.id, report, item.bold,
                                            aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.financiamentoSugerido, report, item.bold,
                                            false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    {values.objComparacaoFinanciamentos.idFinanciamentoAlternativo && (
                                        <>
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosValor(item.financiamentoAlternativo, report, item.bold,
                                                    false, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>
                                            
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosValor(item.valor, report, item.bold,
                                                    false, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>

                                            {values.taxaJurosAnual !== 0 && (
                                                <TableCellBodyExibeDados
                                                    colSpan={headList[colSpan++].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosValor(item.saldo, report, item.bold,
                                                        false, aumentoLetra, aumentoLetraReport, values)}
                                                </TableCellBodyExibeDados>
                                            )}
                                        </>
                                    )}

                                    {estudo.current.descricaoFinanciamentoSugeridoValorAluguelAposContemplacao && (
                                        <>
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosValor(
                                                    item.financiamentoSugeridoValorAluguelAposContemplacao, report, item.bold,
                                                        false, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosValor(
                                                    item.financiamentoSugeridoSaldoAluguelAposContemplacao, report, item.bold,
                                                        false, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>

                                            {estudo.current.percValorizacaoImovelAluguelAposContemplacao && (
                                                <>
                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {formataTableCellBodyExibeDadosValor(
                                                            item.financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao,
                                                                report, item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                                    </TableCellBodyExibeDados>

                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {formataTableCellBodyExibeDadosValor(
                                                            item.financiamentoSugeridoValorImovelAposContemplacao,
                                                                report, item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                                    </TableCellBodyExibeDados>
                                                    
                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {formataTableCellBodyExibeDadosValor(
                                                            item.financiamentoSugeridoResultadoAluguelAposContemplacao,
                                                                report, item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                                    </TableCellBodyExibeDados>

                                                    {estudo.current.descricaoSaldoVendaAposQuitacao && (
                                                        <>
                                                            <TableCellBodyExibeDados
                                                                colSpan={headList[colSpan++].colSpan}
                                                            >
                                                                {formataTableCellBodyExibeDadosValor(
                                                                    item.financiamentoSugeridoSaldoVendaAposQuitacao,
                                                                        report, item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                                            </TableCellBodyExibeDados>

                                                            <TableCellBodyExibeDados
                                                                colSpan={headList[colSpan++].colSpan}
                                                            >
                                                                {formataTableCellBodyExibeDadosValor(
                                                                    item.financiamentoSugeridoResultadoAluguelAposQuitacao,
                                                                        report, item.bold, false, aumentoLetra, aumentoLetraReport, values)}
                                                            </TableCellBodyExibeDados>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}

                                    {values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista && (
                                        <>
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosValor(
                                                    item.saldoPagtoFinanciamentoSugeridoAVista, report, item.bold,
                                                        false, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>

                                            {!values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                                            values.objComparacaoFinanciamentos.valorPagtoParcelasFinanciamentoReceitaMensal && (
                                                <TableCellBodyExibeDados
                                                    colSpan={headList[colSpan++].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosValor(
                                                        item.saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal, report, item.bold,
                                                            false, aumentoLetra, aumentoLetraReport, values)}
                                                </TableCellBodyExibeDados>
                                            )}
                                        </>
                                    )}
                                </TableRowBodyExibeDados>
                            )
                            :
                            (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                />
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>
            </div>
        )
    }

    return (
        report || relatorioModoApresentacao(values)
            ?
                <ComparacaoFinanciamentoTabelaDetalhe/>
            :
                <GridContainer
                    className='justify-center mt-5'
                >
                    <GridItem10>
                        <DivOverflowX>
                            <ComparacaoFinanciamentoTabelaDetalhe/>
                        </DivOverflowX>
                    </GridItem10>
                </GridContainer>
    )
}

export default EstudoFormComparacaoFinanciamentoTabelaDetalhe